import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

const searchJsx = (result, q, node) => {
  if (isPlainObject(node)) {
    const children = get(node, ['props', 'children']);
    if (!children) {
      return result;
    }
    return searchJsx(result, q, children);
  }
  if (Array.isArray(node)) {
    const matches = node
      .map((n) => searchJsx(result, q, n))
      .filter((res) => res)
      .reduce((acc, arr) => acc.concat(arr), []);
    if (!matches.length) {
      return result;
    }
    return Array.isArray(result) ? result.concat(matches) : matches;
  }
  if (typeof node === 'string') {
    const re = new RegExp(q, 'gi');
    const match = node.toLowerCase().match(re);
    if (!match) {
      return result;
    }
    return Array.isArray(result) ? result.concat(match) : match;
  }
  return result;
};

export default searchJsx;
